import { Box } from "@otrium/core";
import { FC, useEffect, useRef } from "react";
import { RedirectData } from "src/molecules/ExpressCheckout/ExpressCheckout";

interface RedirectFormProps {
  redirectData: RedirectData;
}

const RedirectForm: FC<RedirectFormProps> = ({ redirectData }) => {
  const { PaReq, MD, TermUrl, method, url } = redirectData;
  const ref = useRef<HTMLFormElement>(null);

  useEffect(() => {
    if (PaReq && MD && TermUrl && method && url) {
      ref.current?.submit();
    }
  }, [MD, PaReq, TermUrl, method, url]);

  return (
    <Box
      ref={ref}
      as="form"
      id="redirect-form"
      display="none"
      action={url}
      method={method}
      onSubmit={() => {}}
    >
      <input type="text" name="PaReq" value={PaReq} />
      <input type="text" name="MD" value={MD} />
      <input type="text" name="TermUrl" value={TermUrl} />
    </Box>
  );
};

export default RedirectForm;
